import { useState } from "react"

import PageHeader from "../components/PageHeader"
import TextInput from "../components/TextInput"
import Button from "../components/Button"
import Spinner from "../components/Spinner"
import TableResult from "../components/TableResult"
import ErrorResult from "../components/ErrorResult"
import ModelSelect from "../components/ModelSelect"
import Checkbox from "../components/Checkbox"

import {
  nerPosConfig,
  NER_POS_MODELS
} from "../config/nerPos"

import type { NerPosRequest, NerPosResponse } from "../types/nerPos"

import { callAPI } from "../lib/api"
import { type APIError } from "../types/api"

export default function NerPos() {

  const [config, setConfig] = useState<NerPosRequest>({
    text: "",
    model: "roberta_nepali",
    task: "ner_pos"
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [result, setResult] = useState<NerPosResponse | APIError | null>(null)
  const [isNerChecked, setNER] = useState<boolean>(true)
  const [isPosChecked, setPOS] = useState<boolean>(true)

  const handleRun = async () => {
    if (loading) return

    if (!config.text.trim()) {
      setResult({
        error: "Please enter some text."
      })
      return
    }

    if (
      config.text.trim().split(/\s+/).length <
      nerPosConfig.input_text_min_length
    ) {
      setResult({
        error: `Please enter at least ${nerPosConfig.input_text_min_length} words`
      })
      return
    }

  if (!isNerChecked && !isPosChecked) {
    setResult({
      error: "At least one of the task must be selected."
    })
    return
  }

    setLoading(true)
    setResult(null)
    
    const payload: NerPosRequest = {...config, task: isNerChecked && isPosChecked ? "ner_pos" : isNerChecked ? "ner" : "pos" }

    try {
      const data = await callAPI<NerPosRequest, NerPosResponse>(
        nerPosConfig.endpoint,
        payload
      )

      setResult(data)
    } catch (err: any) {
      setResult({
        error: err.message
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="max-w-4xl mx-auto p-6">
      <PageHeader
        title={nerPosConfig.title}
      />

      <TextInput
        label="Input Text"
        value={config.text}
        onChange={(value) =>
          setConfig((prev) => ({ ...prev, text: value }))
        }
      />

      <div className="mt-4">
        <label className="block font-medium mb-2">
          Select Task
        </label>

        <div className="flex gap-6">
          <Checkbox
            label="NER"
            checked={isNerChecked}
            onChange={setNER}
          />

          <Checkbox
            label="POS"
            checked={isPosChecked}
            onChange={setPOS}
          />
        </div>
      </div>

      <ModelSelect
        models={NER_POS_MODELS}
        value={config.model}
        onChange={(value) =>
          setConfig((prev) => ({ ...prev, model: value }))
        }
      />

      <Button
        label="Predict"
        onClick={handleRun}
        loading={loading}
      />

      {loading && <Spinner />}

      <div className="mt-6">
        {result === null ? null : "error" in result ? (
          <ErrorResult message={result.error} />
        ) : (
          <TableResult result={result} />
        )}
      </div>

      <img
        src="./bg.jpg"
        className="object-cover fixed top-0 left-0 w-screen h-screen -z-10 sm:object-fill"
        alt="background"
      />
    </div>
  )
}